import _ from 'lodash'
import * as React from 'react'
import { TREE } from '../../config/routeType'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Search, SkipPrevious, FormatClearSharp } from '@mui/icons-material'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import { getAllDataByTreesFilters, getAdvancedSearch } from '../../services'
import * as rdx from '../../redux/slices/Search/input'
import { Box, Divider } from '@mui/material'
import Button from '../BottonCustom'

const COLOR_POPUP = 'var(--color-primary)'
const COLOR_WHITE = '#fffafa'
const MESSAGE =
  'Oops! No se encuentraron registros, intente nuevamente o recarge la página. :)'

const styleDefault = {
  color: COLOR_POPUP,
  border: `1px solid ${COLOR_POPUP}`,
  width: 'auto',
  fontSize: '12px',
  '&:hover': { backgroundColor: COLOR_POPUP, color: COLOR_WHITE },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
}
const styleAdvancedSearchButton = mW => ({
  color: 'grey',
  width: 'auto',
  minWidth: mW ? 'auto' : '64px',
  fontSize: '12px',
  textTransform: 'none',
  '&:hover': { color: COLOR_POPUP },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
  mr: 0,
  ml: 0,
})
const styleBackToButton = {
  color: COLOR_POPUP,
  textTransform: 'none',
  width: 'auto',
  fontSize: '12px',
  '&:hover': { color: COLOR_POPUP },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
}

const FooterButtons = props => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const [loadingResetButton, setLoadingResetButton] = React.useState(false)
  const { value: isOpenDrawerRight } = useSelector(state => state.drawerRight)
  const filter = useSelector(state => state.filterSearch.filter)
  const filterEnable = useSelector(state => state.filterSearch.enable)

  const wWSmall = props.windowWidth < 410

  const handleFilters = async () => {
    try {
      if (isOpenDrawerRight) {
        dispatch(show(false))
        dispatch(codeTree(null))
        navigate(`/${TREE}`)
      }

      let listCopy = [...props.filtersList]
      const deleteEmptyInputText = _.remove(listCopy, o => {
        if (_.includes(['feature', 'phytosanitary', 'potential_risks'], o.type))
          return !Boolean(o.filterList2.length)
        return !Boolean(o.filterList1.length)
      })

      const updateUsedFilters = _.map(listCopy, obj => ({
        ...obj,
        usedType: obj.type,
        usedFilter1: obj.filterList1,
        usedFilter2: obj.filterList2,
      }))

      const geojson = await getAdvancedSearch(listCopy)
      if (!Object.keys(geojson).length) window.alert(MESSAGE)
      else {
        dispatch(show(false))
        dispatch(codeTree(null))
        dispatch(rdx.setFiltersList(updateUsedFilters)) // (1)
        dispatch(setFeature(geojson)) // (2)
        dispatch(rdx.setFilterState(true)) // (3)
        dispatch(rdx.setAdvancedSearchUsed(props.advancedSearch))
        dispatch(rdx.basicListInitial())
        dispatch(rdx.setEnabledFilter(true))
      }
      if (deleteEmptyInputText.length) dispatch(rdx.setFiltersList(listCopy))
    } catch (err) {
      console.log('Error :>> ', err)
    }
  }

  const handleResetButton = () => {
    setLoadingResetButton(true)
    getAllDataByTreesFilters('', [])
      .then(geojson => {
        if (!Object.keys(geojson).length) window.alert(MESSAGE)
        else {
          dispatch(show(false))
          dispatch(codeTree(null))
          dispatch(setFeature(geojson))
          dispatch(rdx.setFilterState(true))
          dispatch(rdx.basicListInitial())
          dispatch(rdx.filterListInitial())
          dispatch(rdx.setEnabledFilter(false))
        }
      })
      .catch(() => navigate(0))
      .finally(() => setLoadingResetButton(false))
  }

  const handleBackTo = () => {
    dispatch(rdx.setSearchByType(''))
    dispatch(rdx.setSelectedList([]))
    dispatch(rdx.setAdvancedSearch(false))
  }

  // Disable search button after searching
  React.useEffect(() => {
    if (!filter) return
    props.setEnableFilterButton(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  console.log('filtersList :>> ', props.filtersList)

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ display: 'flex', width: 'auto' }}>
        <Button
          variant={wWSmall ? 'outlined' : 'text'}
          text={wWSmall ? <SkipPrevious sx={{ fontSize: 'large', mx: 1 }} /> : 'Regresar'}
          onClick={handleBackTo}
          startIcon={wWSmall ? null : <SkipPrevious />}
          styleButton={styleAdvancedSearchButton(props.windowWidth < 390)}
          size="small"
        />
        {props.windowWidth < 600 && (
          <Divider orientation="vertical" flexItem sx={{ pr: 1 }} />
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 'calc(100% - 72px)',
          pl: 1,
          justifyContent: 'end',
        }}>
        <Button
          variant="text"
          text={wWSmall ? 'Borrar' : 'Limpiar'}
          startIcon={<FormatClearSharp />}
          onClick={handleResetButton}
          styleButton={styleBackToButton}
          size="small"
          disabled={
            (!filterEnable && !Boolean(props.filtersList?.[0]?.usedFilter1.length)) ||
            loadingResetButton
          }
        />
        <Box pr={1} />
        <Button
          text={wWSmall ? <Search sx={{ fontSize: 'large', mx: 1 }} /> : 'Buscar'}
          onClick={handleFilters}
          startIcon={wWSmall ? null : <Search />}
          styleButton={styleDefault}
          size="small"
          disabled={
            !Boolean(
              _.includes(
                ['feature', 'phytosanitary', 'potential_risks'],
                props.filtersList?.[0]?.type
              )
                ? props.filtersList?.[0]?.filterList2.length
                : props.filtersList?.[0]?.filterList1.length
            ) || props.enableFilterButton
          }
        />
      </Box>
    </Box>
  )
}

export default FooterButtons
